// extracted by mini-css-extract-plugin
export var md = "_1v-4";
export var semantic = "_1v-5";
export var sm = "_1v-3";
export var text = "_1v-6";
export var toggleInput = "_1v-0";
export var toggleSwitch = "_1v-1";
export var xs = "_1v-2";